import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Drawer from '@/components/Drawer';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { isEmpty, translatorEnum } from '@/utils/util';
import './index.scss';
import WorkOrderDrawer from './components/WorkOrderDrawer';
import classNames from 'classnames';
import RenderBottomBtn from './components/WorkOrderDrawer/RenderBottomBtn';
import { useIsTakeOverBySelf, useTextToSpeech } from '@/utils/hooks';
import IssueApi from '@/fetch/bussiness/issue';
import { HttpStatusCode } from '@/fetch/core/constant';
import { message } from 'antd';
import { CockpitMode } from '@/utils/type';
import { sendGlobalEvent } from '@/utils/emit';
const MainLayout = () => {
  const { pathname, search } = useLocation();
  const fetchApi = new IssueApi();
  const { issue, newCommon } = useSelector((state: RootState) => state);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showHeader, setShowHeader] = useState<boolean>(false);
  const [showDrawer, setShowDrawer] = useState<boolean>(false);
  const takeOverBySelf = useIsTakeOverBySelf();
  const isSingleView = pathname.includes('/app/singleview');
  const currentSingleViewVehicle = isSingleView
    ? new URLSearchParams(search).get('vehicleName') || ''
    : '';
  const prevIsSingleViewRef = useRef(isSingleView);
  const prevTakeOverBySelfRef = useRef(takeOverBySelf);
  const prevSingleViewVehicleRef = useRef(currentSingleViewVehicle);
  const newIssueList = issue?.list?.filter((val: any) => val.newIssue);
  const reminIssue = issue?.list
    ?.filter((i: any) => i.issueReminder)
    ?.map((i: any) => i.issueNumber);
  useTextToSpeech(
    '您有新的工单啦',
    newIssueList && newIssueList?.length > 0
      ? newIssueList[0]?.issueNumber
      : null
  );

  const collapseDrawerIfExpanded = useCallback(() => {
    if (!showDrawer || !isDrawerOpen) {
      return;
    }
    sendGlobalEvent('CHANGE_DRAWER_STATUS');
  }, [showDrawer, isDrawerOpen]);

  useEffect(() => {
    setShowHeader(!isSingleView);
  }, [isSingleView]);
  useEffect(() => {
    if (reminIssue?.length > 0 && !isDrawerOpen) {
      setIsDrawerOpen(true);
    }
  }, [JSON.stringify(reminIssue)]);
  useEffect(() => {
    setShowDrawer(
      [CockpitMode.LISTENING_MODE, CockpitMode.WATCH_CAR_MODE].includes(
        newCommon.cockpitMode
      )
    );
  }, [newCommon.cockpitMode]);
  useEffect(() => {
    const justEnteredSingleView = !prevIsSingleViewRef.current && isSingleView;
    if (justEnteredSingleView) {
      collapseDrawerIfExpanded();
    }
    prevIsSingleViewRef.current = isSingleView;
  }, [isSingleView, collapseDrawerIfExpanded]);
  useEffect(() => {
    const justTakeOverSuccess =
      !prevTakeOverBySelfRef.current && takeOverBySelf;
    if (isSingleView && justTakeOverSuccess) {
      collapseDrawerIfExpanded();
    }
    prevTakeOverBySelfRef.current = takeOverBySelf;
  }, [isSingleView, takeOverBySelf, collapseDrawerIfExpanded]);
  useEffect(() => {
    if (!isSingleView) {
      prevSingleViewVehicleRef.current = '';
      return;
    }
    const switchedSingleVehicle =
      !!prevSingleViewVehicleRef.current &&
      !!currentSingleViewVehicle &&
      prevSingleViewVehicleRef.current !== currentSingleViewVehicle;
    if (switchedSingleVehicle) {
      collapseDrawerIfExpanded();
    }
    prevSingleViewVehicleRef.current = currentSingleViewVehicle;
  }, [isSingleView, currentSingleViewVehicle, collapseDrawerIfExpanded]);
  const collapseNode = (
    <div className="work-order-icon icon-box">
      <i className="work-order"></i>
      {!isEmpty(issue?.list) && (
        <i className="alarm-num">{issue?.list.length}</i>
      )}
      工单
    </div>
  );

  const cancelNewIssue = (cb?: any) => {
    newIssueList?.length > 0 &&
      fetchApi
        .cancelNewIssue(
          newIssueList.map((v: any) => v.issueNumber),
          newCommon.cockpitNumber
        )
        .then((res) => {
          if (res.code !== HttpStatusCode.Success) {
            message.error(res.message);
          }
        })
        .finally(() => {
          cb && cb();
        });
  };

  return (
    <>
      {showHeader && <Header />}
      {showDrawer && (
        <Drawer
          direction="left"
          classNames="right-flow-box"
          btnWrapperCls="flow-suspended-btn"
          defaultOpened={isDrawerOpen}
          width={627}
          collapseNode={collapseNode}
          handleCollapse={(isOpen) => {
            cancelNewIssue(setIsDrawerOpen(false));
          }}
          handleExpand={(isOpen) => {
            cancelNewIssue(setIsDrawerOpen(true));
          }}
        >
          <WorkOrderDrawer isDrawerOpen={isDrawerOpen} />
        </Drawer>
      )}
      {!isDrawerOpen &&
        newIssueList?.length > 0 &&
        newIssueList?.map((item: any, index: number) => {
          return (
            <div
              key={item.vehicleName}
              className={classNames('message-card', {
                first: index === 0,
                second: index === 1,
              })}
            >
              <img
                className="icon"
                src={
                  item.emergencyIssue
                    ? require('@/assets/images/cockpit/msg_card_urgent.png')
                    : require('@/assets/images/cockpit/msg_card_not_urgent.png')
                }
              ></img>
              <p className="title">
                {item.emergencyIssue
                  ? '紧急工单，建议优先受理！'
                  : '您有新的工单，请及时处理!'}
              </p>

              <p className="msg-content">
                <>{item.vehicleName}</>
                {item.issueEventList
                  ? `${
                      '出现' +
                      item.issueEventList
                        .map((v: any) =>
                          translatorEnum('ALARM_EVENT_ENUM', v.eventType)
                        )
                        .join('、') +
                      '事件'
                    }`
                  : ''}
              </p>
              <div className="bottom-handle-btns">
                <RenderBottomBtn
                  cockpitNumber={newCommon.cockpitNumber}
                  issueInfo={item}
                  isNotification={true}
                />
              </div>
            </div>
          );
        })}
      <Outlet />
    </>
  );
};
export default MainLayout;
